export default "__VITE_PUBLIC_ASSET__c2776a33__"